import './UserAvatar.css';
import type { User } from 'src/services/usersService';

export const UserAvatar = ({
  user,
}: {
  user?: Pick<User, 'first_name' | 'last_name' | 'is_active'>;
}) => {
  const first = user?.first_name?.[0];
  const second = user?.last_name?.[0];

  return (
    <div className={`user-avatar ${user?.is_active ? 'active' : 'onhold'}`}>
      <span>{`${first || ''}${second || ''}`}</span>
    </div>
  );
};
